import { setToast } from '@/entities/toast'
import { widgetWindowsSelector } from '@/entities/widgetWindows'
import { OperationsGanttWidgetWindow } from '@/entities/widgetWindows/models/WidgetWindow'
import { updateWidgetWindow } from '@/entities/widgetWindows/widgetWindowsSlice'
import { TOOL_WIDGETS } from '@/shared/components/Mosaic/models/widgetType'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export const showShiftsOnGantt = createAsyncThunk<void, { shiftIds: EntityId[] }, ThunkApiContext>(
  'operations/showShiftsOnGantt',
  async ({ shiftIds }, { getState, dispatch }) => {
    const state = getState()
    const activeWidgetWindowId = state.widgetWindows.activeWidgetWindowId
    const ganttWidgetWindows = widgetWindowsSelector.selectAll(state)
      .filter((widget) => widget.widgetType === TOOL_WIDGETS.GanttChart)
    
    let selectedGanttWidgetWindow = ganttWidgetWindows.find((widget) => widget.id === activeWidgetWindowId)

    if (!selectedGanttWidgetWindow && ganttWidgetWindows.length > 0) {
      selectedGanttWidgetWindow = ganttWidgetWindows[0]
    }

    if (!selectedGanttWidgetWindow) {
      dispatch(setToast({
        open: true,
        severity: 'error',
        title: 'No gantt chart widget presented in the layout',
        content: 'Drag and drop the gantt chart widget onto the layout before showing the shift on the gantt',
      }))

      return
    }

    const existingShiftIds = (selectedGanttWidgetWindow as OperationsGanttWidgetWindow).shiftIds || []
    const newShiftIds = shiftIds.filter(shiftId => !existingShiftIds.includes(shiftId))
    
    if (newShiftIds.length === 0) {
      return
    }

    // Add shift to map widget window
    dispatch(updateWidgetWindow({
      id: selectedGanttWidgetWindow.id,
      changes: {
        shiftIds: [...existingShiftIds, ...newShiftIds],
      },
    }))
  })